var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.mall_classify_spec_id)?_c('TableRender',{attrs:{"Service":_vm.MallClassifySpecOptionService}},[_c('TableText',{attrs:{"prop":"display_name","label":"规格参数","width":120}}),_c('TableAction',{attrs:{"buttons":[
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":160}})],1):_c('el-alert',{attrs:{"title":"请选择规格","type":"info","show-icon":"","closable":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }